// src/app/api/apiSlice.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials } from '../../features/auth/authSlice'

const baseQuery = fetchBaseQuery({
  //baseUrl: 'http://localhost:5000', // सुनिश्चित करें कि यह आपके बैकएंड का सही बेस URL है
  baseUrl: 'https://nirakarsatguru.org',
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token

    if (token) {
      headers.set("authorization", `Bearer ${token}`)
    }
   
    return headers
  }
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)

  if (result?.error?.status === 403) {
    console.log('sending refresh token')

    const refreshResult = await baseQuery('/api/v1/user/refresh', api, extraOptions) // अपने रिफ्रेश टोकन एंडपॉइंट को वेरीफाई करें

    if (refreshResult?.data) {
      api.dispatch(setCredentials({ ...refreshResult.data }))
      result = await baseQuery(args, api, extraOptions)
    } else {
      if (refreshResult?.error?.status === 403) {
        refreshResult.error.data.message = "Your login has expired."
      }
      return refreshResult
    }
  }

  return result
}

export const apiSlice = createApi({
    // **महत्वपूर्ण बदलाव यहाँ:**
    // FormData के लिए 'Content-Type' को मैन्युअल रूप से सेट करने या body को फिर से बनाने की आवश्यकता नहीं है।
    // fetchBaseQuery FormData को ऑटोमेटिकली सही `multipart/form-data` हेडर के साथ हैंडल करता है।
    // आपकी पिछली `overrideFetchBaseQuery` लागू करने से FormData टूट रहा था।
    // इसे पूरी तरह से हटाना या यदि कोई बहुत विशिष्ट कारण है तो उसे ठीक से लागू करना सबसे अच्छा है।
    // मैं यहाँ इसे हटा रहा हूँ क्योंकि अधिकांश मामलों में इसकी आवश्यकता नहीं होती है।
    // यदि आपको भविष्य में किसी विशेष हेडर या body मैनिपुलेशन की आवश्यकता हो,
    // तो आप इसे `prepareHeaders` या सीधे एंडपॉइंट के `query` फ़ंक्शन में कर सकते हैं।

    baseQuery: baseQueryWithReauth,
    // **नया टैग प्रकार 'CarouselItem' जोड़ा गया है**
  tagTypes: ['Event','Bhajan', 'User','Quote','Meditation', 'CarouselItem'], // <--- 'CarouselItem' यहाँ जोड़ा गया है
  endpoints: builder => ({})
})